/**
 * SGKC026A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface LocationgroupsupplypointExtractionconditionInformationDto {

    /**
     * 会社コード
     */
    companycode?: string;
    /**
     * ＬＰ販売形態コード
     */
    lpSalesformcode?: string;
    /**
     * 地点群供給地点区分番号
     */
    locationgroupSuppntDivisionnumber?: string;
    /**
     * 地点群供給地点区分名称
     */
    locationgroupSuppntDivisionname?: string;
    /**
     * 承認単価権限管理ID
     */
    apprvTankaauthorityManagementid?: string;
}

